if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    if (document.getElementById("ot-sdk-btn") && document.getElementById("tertiary-navigation")) {
        document.getElementById("tertiary-navigation").appendChild(document.getElementById("ot-sdk-btn"))
    }

    $('.sym-slides').slick({
        accessibility: false
    });
    
    $('.gallery-slider').slick({
        accessibility: false
    });
    $(".arrow-prev .slick-prev").click(function(){
        $(".gallery-slider").slick("slickPrev");
    });
    $(".arrow-next .slick-next").click(function(){
        $(".gallery-slider").slick("slickNext");
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    //header scroll
	let scrollpos = window.scrollY;
	const full_header = document.querySelector('.header');

    window.addEventListener('scroll', function() { 
        scrollpos = window.scrollY;

		if (scrollpos >= 80) { 
			full_header.classList.remove("up"),
			full_header.classList.add("down")
		}
		else { 
			full_header.classList.remove("down"),
			full_header.classList.add("up")
		}
		//console.log(scrollpos)
	});

    const animateHTML = function () {
        let elems,
            elemsShow,
            windowHeight;
        let init = function () {
            elems = document.getElementsByClassName('hide-object');
            elemsShow = document.getElementsByClassName('show-object');
            windowHeight = window.innerHeight;
            addEventHandlers();
        }; 
        let addEventHandlers = function () {
            window.addEventListener('scroll', checkPosition);
            window.addEventListener('resize', init);
        };
        let checkPosition = function () {
            for (let i = 0; i < elems.length; i++) {
                let posFromTop = elems[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight <= 0) {
                    elems[i].className = elems[i].className.replace('hide-object', 'show-object')
                }
            } 
            for (let i = 0; i < elemsShow.length; i++) {
                let posFromTop = elemsShow[i].getBoundingClientRect().top;
                if (posFromTop - windowHeight >= 0) {
                    elemsShow[i].className = elemsShow[i].className.replace('show-object', 'hide-object')
                } 
            } 
        };
        return {
            init: init 
        }
    };
    animateHTML().init();

    const intro_copy = document.querySelector('.top-content-js');

    if(intro_copy){
		document.getElementsByClassName('top-content-js')[0].classList.add('appear');
	}

    const intro_img = document.querySelector('.top-img-js');

    if(intro_img){
		document.getElementsByClassName('top-img-js')[0].classList.add('appear');
	}

    //tabs sections
	const tabLinks = document.querySelectorAll('.js-tabs-menu a');

	for (let i = 0; i < tabLinks.length; i++) {
		tabLinks[i].onclick = function() {
			let target = this.getAttribute('href').replace('#', '');
			let sections = document.querySelectorAll('div.tab-content');
			for(let j=0; j < sections.length; j++) {
				sections[j].style.display = 'none';
			}
			document.getElementById(target).style.display = 'block';
			for(let k=0; k < tabLinks.length; k++) {
				tabLinks[k].classList.remove('active');
			}
			this.classList.add('active');
			return false;
		}
	}

    jQuery(document).ready(function ($) { 
        $('.privary-navigation ul a[href*=\\#]:not([href=\\#])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') 
                || location.hostname == this.hostname) {

                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 100
                    }, 1000);
                    return false;
                }
            }
        });
    });

    if(window.location.hash){
        // smooth scroll to the anchor id
        $('html,body').animate({
            scrollTop:$(window.location.hash).offset().top - 100 + 'px'
        },1000,'swing');
    }

    function setActiveListElements(event){
		// Get the offset of the window from the top of page
		var windowPos = $(window).scrollTop();

        $('.privary-navigation li a[href^="#"]').each(function() { 
            var anchorId = $(this);
			var target = $(anchorId.attr("href"));
			
			if (target.length > 0) {
				if ((target.position().top - ($('.header').outerHeight() + 80)) <= windowPos) {
					$('.privary-navigation li a').removeClass("active");
					anchorId.addClass("active");
				}
			}
		});
	}
		
	$(window).scroll(function() {
		setActiveListElements(); 
	});

    $('.sym-slides').slick({
        accessibility: false
    });

    
})();